import { Button } from 'antd';
import { useEffect, useState } from 'react';

import styles from './profile.module.scss';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import Icon from 'utils/icon';
import avatar from 'assets/images/avatar.png';
import LoadingComponent from 'components/loadingComponent/loadingComponent';
import { Admin } from 'modules/admins/models/Admin';
import authService from 'core/services/auth';

import defaultAvatar from 'assets/images/defaultAvatar.webp';

function ProfilePage() {
	const navigate = useNavigate();
	const [activeRoute, setActiveRoute] = useState<'data' | 'billing'>('data');
	const [admin, setAdmin] = useState<Admin | null>();

	useEffect(() => {
		setAdmin(authService.getUser());
	}, []);

	const onLogout = () => {
		authService.clearAuthData();
		navigate('/login');
	};

	return (
		<>
			<div className="pageHeader">
				<h3>My Profile</h3>
			</div>

			<div className={`sectionContainer`}>
				<div className={styles.data}>
					<img src={admin?.avatar_url ? admin.avatar_url : defaultAvatar} />
					<div>
						<div>
							<div className={styles.data_name}>
								<h5>{admin?.name}</h5>
								<Icon name="verified" />
								<span className={`status ${admin?.active ? 'active' : 'inactive'}`}>{admin?.active ? 'Active' : 'Inactive'}</span>
							</div>

							<div className={styles.data_connection}>
								{/* <div>
									<Icon name="contact" />
									{admin?.phone}
								</div> */}
								<div>
									<Icon name="mail" />
									{admin?.email}
								</div>
							</div>

							{/* <div className={styles.data_details}>
								<div>
									<p>
										<Icon name="upArrow" width={12} height={12} />
										SAR4,500
									</p>
									<span>Current Wallet</span>
								</div>

								<div>
									<p>
										<Icon name="downArrow" width={12} height={12} />
										75
									</p>
									<span>Users</span>
								</div>
							</div> */}
						</div>
						<Button className="danger" onClick={onLogout} icon={<Icon name="logout2" />}>
							Logout
						</Button>
					</div>
				</div>

				{/* <div className={styles.linksDiv}>
					<NavLink to="data" className={({ isActive }) => (isActive ? styles.active : '')}>
						My profile
					</NavLink>
					<NavLink to="billing" className={({ isActive }) => (isActive ? styles.active : '')}>
						Billing details
					</NavLink>
				</div> */}
			</div>

			<Outlet />
		</>
	);
}

export default ProfilePage;
